import '../../select/v1/select'

export default function AjaxifyGrid(element, custom_events) {
    let grid_counter = 0;
    $('.grid, .grid-header').each(function() {
      $(this).attr('data-grid-id', grid_counter);
      if ($(this).hasClass('grid')) {
        grid_counter++;
      }
    })

    let self = element
    let grid = self
    self.id = self.attr('data-grid-id')
    self.is_carousel = self.closest('.carousel').length >= 1;
    self.meta_filter_keys = []
    self.meta_filters = {}
    self.tax_filter_keys = []
    self.tax_filters = {}
    self.grid_footer = self.next('.grid-footer')
    self.grid_header = $('.grid-header[data-grid-id=' + self.id + ']')
    self.container = self.grid_footer.find('.ajax-load-more__container')
    self.query = self.grid_footer.find('input[name=query]').val()
    self.content_type = self.grid_footer.find('input[name=content_type]').val()
    self.style = self.grid_footer.find('input[name=style]').val()
    self.search = self.grid_footer.find('input[name=search]').val()
    self.action = self.grid_footer.find('input[name=action]').val()
    self.lang = false;
    if ($('head.language-fr').length) {
      self.lang = 'fr';
    } else if ($('head.language-en').length) {
      self.lang = 'en';
    }
    if (self.is_carousel) {
      self.closest('.carousel').wrap('<div class="ajax-load-more__wrapper"/>');
      grid.closest('.ajax-load-more__wrapper').append(self.find('.grid__loader').clone())
      grid.find('.grid__loader').remove();
    } else {
      grid.wrap('<div class="ajax-load-more__wrapper"/>');
    }
    self.wrapper = grid.closest('.ajax-load-more__wrapper')
    self.wrapper.css('max-height', grid.outerHeight() + 'px');
    if (self.is_carousel) {
      self.wrapper.addClass('--carousel')
      self.swiper = self.closest('.carousel').data('carousel').swiper
    }

    self.grid_header.find('.--dropdown').each(function() {
      let dropdown = $(this);
      var dropdwon_el = $('<select class="js-ajaxify-select"></select>');
      dropdown.find('.js-ajaxify-grid-item').each(function(i) {
        var option = $(this);
        option.attr('data-id', i);
        $('<option value="' + i + '">' + option.html() + '</option>').appendTo(dropdwon_el);
      })
      dropdwon_el.prependTo(dropdown);
      dropdwon_el.on('change', function() {
        dropdown.find('.js-ajaxify-grid-item[data-id=' + $(this).val() + ']').click();
      });
      dropdwon_el.Select();
    })

    self.grid_header.find('.js-ajaxify-grid-item[data-filter-meta]').each(function() {
      self.meta_filter_keys.push($(this).attr('data-filter-meta'))
    })
    self.meta_filter_keys = self.meta_filter_keys.filter((element, index) => {
      return self.meta_filter_keys.indexOf(element) === index;
    });

    self.grid_header.find('.js-ajaxify-grid-item[data-filter-tax]').each(function() {
      self.tax_filter_keys.push($(this).attr('data-filter-tax'))
    })
    self.tax_filter_keys = self.tax_filter_keys.filter((element, index) => {
      return self.tax_filter_keys.indexOf(element) === index;
    });

    self.grid_footer.find('.ajax-load-more__btn').each(function() {
      let load_more = $(this)

      if (self.wrapper.find('.ajax-load-more__end-page').length > 0) {
        self.container.addClass('--fully-loaded')
      }

      load_more.click(function(){
        self.modifyGrid('update')
      })
    })

    self.grid_header.find('.js-ajaxify-grid-search').on('input', function(){
      self.grid_footer.find('input[name=search]').val($(this).val())
    })

    self.grid_header.find('.grid-search').submit(function(e) {
      e.preventDefault();
      self.modifyGrid('replace')
    })

    self.grid_header.find('.js-ajaxify-grid-item').click(function(){
      let filter = $(this)
      var is_multiple = filter.closest('.grid-filters').hasClass('--multiple')
      if (filter.attr('data-sorting')) {
        self.sort = {
          key: filter.attr('data-sorting'),
          order: filter.attr('data-sorting-order'),
          meta: filter.attr('data-sorting-meta')
        };
        self.grid_footer.find('input[name=sorting]').val(JSON.stringify(self.sort))
        self.modifyGrid('replace');
      }
      if (filter.attr('data-filter-meta')) {
        if (filter.hasClass('reset')) {
          self.grid_header.find('.js-ajaxify-grid-item.--selected[data-filter-meta="' + filter.attr('data-filter-meta') + '"]').removeClass('--selected');
          filter.addClass('--selected');
        } else if (filter.hasClass('--selected')) {
          filter.removeClass('--selected');
          if (filter.closest('.grid-filters__list').find('.--selected').length == 0) {
            filter.closest('.grid-filters__list').find('.reset').addClass('--selected')
          }
        } else {

          if (!is_multiple) {
            self.grid_header.find('.js-ajaxify-grid-item.--selected[data-filter-meta="' + filter.attr('data-filter-meta') + '"]').removeClass('--selected');
          } else {
            self.grid_header.find('.js-ajaxify-grid-item.--selected.reset[data-filter-meta="' + filter.attr('data-filter-meta') + '"]').removeClass('--selected');
          }
          filter.addClass('--selected');
        }
        self.meta_filters = {};
        self.meta_filter_keys.forEach(function(filter_key) {
          var meta_filters = [];
          self.grid_header.find('.js-ajaxify-grid-item.--selected[data-filter-meta="' + filter_key + '"]').each(function() {
            if (!$(this).hasClass('reset')) {
              if ($(this).attr('data-filter-value').includes('[')) {
                var values = JSON.parse($(this).attr('data-filter-value'));
                meta_filters = meta_filters.concat(values);
              } else {
                meta_filters.push($(this).attr('data-filter-value'))
              }

            }
          })
          self.meta_filters[filter_key] = meta_filters;
        })
        self.grid_footer.find('input[name=meta_filters]').val(JSON.stringify(self.meta_filters))
        self.modifyGrid('replace');
      }
      if (filter.attr('data-filter-tax')) {
        if (filter.hasClass('reset')) {
          self.grid_header.find('.js-ajaxify-grid-item.--selected[data-filter-tax="' + filter.attr('data-filter-tax') + '"]').removeClass('--selected');
          filter.addClass('--selected');
        } else if (filter.hasClass('--selected')) {
          filter.removeClass('--selected');
          if (filter.closest('.grid-filters__list').find('.--selected').length == 0) {
            filter.closest('.grid-filters__list').find('.reset').addClass('--selected')
          }
        } else {
          if (!is_multiple) {
            self.grid_header.find('.js-ajaxify-grid-item.--selected[data-filter-tax="' + filter.attr('data-filter-tax') + '"]').removeClass('--selected');
          } else {
            self.grid_header.find('.js-ajaxify-grid-item.--selected.reset[data-filter-tax="' + filter.attr('data-filter-tax') + '"]').removeClass('--selected');
          }
          filter.addClass('--selected');
        }
        self.tax_filters = {};
        self.tax_filter_keys.forEach(function(filter_key) {
          var tax_filters = [];
          self.grid_header.find('.js-ajaxify-grid-item.--selected[data-filter-tax="' + filter_key + '"]').each(function() {
            if (!$(this).hasClass('reset')) {
              tax_filters.push($(this).attr('data-filter-value'))
            }
          })
          if (tax_filters.length > 0) {
            self.tax_filters[filter_key] = tax_filters;
          }
        })
        self.grid_footer.find('input[name=tax_filters]').val(JSON.stringify(self.tax_filters))
        self.modifyGrid('replace');
      }
      is_multiple = false;
    })

    self.modifyGrid = function(modify_action) {
      let page = self.grid_footer.find('input[name=page]').val()
      if (modify_action == 'replace') {
        page = 1
        self.grid_footer.find('input[name=used_ids]').val('[]');
      }
      self.container.removeClass('--fully-loaded')
      if (self.xhr) {
        self.xhr.abort()
      }
      self.xhr = $.ajax({
        url: self.action,
        data : {
          action: 'grid_update',
          query: self.query,
          style: self.style,
          content_type: self.content_type,
          sorting: self.grid_footer.find('input[name=sorting]').val(),
          sorting_order: self.grid_footer.find('input[name=sorting_order]').val(),
          meta_filters: self.grid_footer.find('input[name=meta_filters]').val(),
          tax_filters: self.grid_footer.find('input[name=tax_filters]').val(),
          search_key: self.grid_footer.find('input[name=search]').val(),
          page: page,
          page_context: self.grid_footer.find('input[name=page_context]').val(),
          used_ids: self.grid_footer.find('input[name=used_ids]').val(),
          lang: self.lang,
        },
        type: 'POST',
        beforeSend:function(xhr){
          if (modify_action == 'update') {
            self.container.addClass('--loading')
            self.wrapper.css('max-height', grid.outerHeight() + 'px');
          } else if (modify_action == 'replace') {
            self.container.addClass('--replacing')
            if (self.is_carousel) {
              self.wrapper.addClass('--loading')
            } else {
              grid.addClass('--loading')
            }
            self.wrapper.css('max-height', '200px');
            self.find('.grid__item').addClass('--hidden')
          }
        },
        success:function(data){
          if (self.is_carousel) {
            //Make sure swiper exist incase it was kill on resize
            self.swiper = self.closest('.carousel').data('carousel').swiper
          }
          var data = $(data);
          data = custom_events.beforeAppend(data)
          self.grid_footer.find('input[name=page]').val(parseInt(page) + 1)
          if(data.find('.ajax-load-more__end-page, .grid__no-data').length > 0) {
            self.container.addClass('--fully-loaded')
          }
          if (data.find('.grid').length > 0) {
            if (data.find('.used-ids').length > 0 && self.content_type != 'custom') {
              var last_used_ids = data.find('.used-ids').html()
              var old_used_ids = self.grid_footer.find('input[name=used_ids]').val()
              var new_used_ids = old_used_ids.replace("]", "") + ',' + last_used_ids.replace("[", "");
              self.grid_footer.find('input[name=used_ids]').val(new_used_ids)
            }

            if (modify_action == 'replace') {
              if (self.is_carousel) {
                self.swiper.removeAllSlides();
              } else {
                grid.find('.grid__item').remove();
              }
            }
            data.find('.grid__item').each(function() {
              if (self.is_carousel) {
                $(this).addClass('swiper-slide')
                self.swiper.appendSlide($(this))
              } else {
                $(this).addClass('--hidden')
                grid.find('.grid__loader').before($(this).clone());
              }
            })
            if (self.is_carousel) {
              self.swiper.slideToLoop(0);
            }
          } else {
            grid.append(data.html());
          }
          if (modify_action == 'update') {
            self.container.removeClass('--loading')
            self.wrapper.css('max-height', grid.outerHeight() + 'px');
            self.wrapper.find('.grid__item').removeClass('--hidden')
            custom_events.afterUpdate(grid)
          } else if (modify_action == 'replace') {
            self.container.removeClass('--replacing')
            if (self.is_carousel) {
              self.wrapper.removeClass('--loading')
            } else {
              grid.removeClass('--loading')
            }
            self.wrapper.css('max-height', grid.outerHeight() + 'px');
            grid.find('.grid__item').removeClass('--hidden')
            custom_events.afterReplace(grid)
          }
        }
      });
    }

    $(window).on('resize orientationchange load', function() {
      self.wrapper.css('max-height', grid.outerHeight() + 'px');
    })

    custom_events.afterInit(grid)
}

export function AjaxifyGrid_CoreInit(custom_events = []) {
  $(function() {
    $('.grid.--ajaxified').each(function () {
      let self = $(this);
      var default_events = {
        afterInit: function(grid) {},
        afterReplace: function(grid) {},
        afterUpdate: function(grid) {},
        beforeAppend: function(new_content) {return new_content},
      }
      custom_events.forEach(function(item) {
        if (!item.classSelector || self.hasClass(item.classSelector)) {
          default_events = $.extend(true, default_events, item)
        }
      })
      AjaxifyGrid(self, default_events);
    })
  });
}
